export default {
  methods: {
    getPlatformIcon(code) {
      if (this.$store.state.platforms) {
        let platform = this.$store.state.platforms.find(p => {
          if (p.code == code) {
            return p;
          }
        });
        if (platform) {
          return platform.mdi_icon;
        }
      }
      return "mdi-help";
    },
  }
}
